export class CivilStatus {
    name: string;
    id: number;
    code: string;
}